"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    arenas: function() {
        return _arenas.arenas;
    },
    brands: function() {
        return _brands.brands;
    },
    championships: function() {
        return _championships.championships;
    },
    defaultArenaConfig: function() {
        return _arenas.defaultArenaConfig;
    },
    factions: function() {
        return _factions.factions;
    },
    feuds: function() {
        return _feuds.feuds;
    },
    getCollectionByBrand: function() {
        return getCollectionByBrand;
    },
    reigns: function() {
        return _reigns.reigns;
    },
    shows: function() {
        return _shows.shows;
    },
    wrestlers: function() {
        return _wrestlersjson.default;
    }
});
const _arenas = require("./arenas");
const _brands = require("./brands");
const _shows = require("./shows");
const _feuds = require("./feuds");
const _factions = require("./factions");
const _championships = require("./championships");
const _reigns = require("./reigns");
const _wrestlersjson = /*#__PURE__*/ _interop_require_default(require("./wrestlers.json"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const collectionIncludes = (collection, id)=>{
    return collection.filter((item)=>{
        var _item_brandIds;
        return item === null || item === void 0 ? void 0 : (_item_brandIds = item.brandIds) === null || _item_brandIds === void 0 ? void 0 : _item_brandIds.includes(id);
    });
};
function getCollectionByBrand(brandId) {
    const filteredChampionships = _championships.championships.filter((item)=>{
        var _item_brandIds;
        return item === null || item === void 0 ? void 0 : (_item_brandIds = item.brandIds) === null || _item_brandIds === void 0 ? void 0 : _item_brandIds.includes(brandId);
    });
    const championshipIds = filteredChampionships.map((item)=>item.id);
    const filteredReigns = _reigns.reigns.filter((item)=>championshipIds.includes(item.championshipId));
    return {
        arenas: _arenas.arenas,
        brands: _brands.brands.filter((item)=>item.id === brandId),
        championships: filteredChampionships,
        reigns: filteredReigns,
        factions: collectionIncludes(_factions.factions, brandId),
        feuds: collectionIncludes(_feuds.feuds, brandId),
        shows: collectionIncludes(_shows.shows, brandId),
        wrestlers: collectionIncludes(_wrestlersjson.default, brandId)
    };
}
